module.exports = __webpack_public_path__ + "static/couple-sitted-face-right-700w-216944b1e17651fa6862862891b7074d.png";